import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, ChartNoAxesCombined, Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute(
	"/_auth/app/_app/help/user-guide/feasibility",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();

	const tasks = [
		t("help.guideFeasibilityTask1"),
		t("help.guideFeasibilityTask2"),
		t("help.guideFeasibilityTask3"),
		t("help.guideFeasibilityTask4"),
	];

	return (
		<div className="p-4 sm:p-6 max-w-4xl mx-auto space-y-6">
			{/* Mobile Back Button */}
			<Link
				to="/app/help/user-guide"
				className="md:hidden flex items-center gap-2 text-primary"
			>
				<ArrowLeft className="w-4 h-4" />
				{t("common.back")}
			</Link>

			{/* Header */}
			<div className="flex items-center space-x-3">
				<div className="w-10 h-10 sm:w-12 sm:h-12 bg-purple-50 rounded-lg flex items-center justify-center shrink-0">
					<ChartNoAxesCombined className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600" />
				</div>
				<div className="min-w-0">
					<h1 className="text-xl sm:text-3xl font-bold text-base-content">
						{t("help.guideFeasibilityTitle")}
					</h1>
					<p className="text-sm sm:text-lg text-base-content/70">
						{t("help.guideFeasibilityDescription")}
					</p>
				</div>
			</div>

			{/* Overview + key tasks */}
			<Card>
				<CardHeader>
					<CardTitle className="flex items-center space-x-2">
						<ChartNoAxesCombined className="h-5 w-5" />
						<span>{t("help.overviewLabel")}</span>
					</CardTitle>
				</CardHeader>
				<CardContent className="space-y-4">
					<p className="text-base-content/80">
						{t("help.guideFeasibilityOverview")}
					</p>
					<div>
						<h4 className="font-medium text-base-content mb-2">
							{t("help.whatYouCanDo")}
						</h4>
						<ul className="space-y-2 text-base-content/80">
							{tasks.map((task) => (
								<li key={task} className="flex items-start gap-2">
									<span className="text-primary mt-1">•</span>
									<span>{task}</span>
								</li>
							))}
						</ul>
					</div>
				</CardContent>
			</Card>

			{/* Tip */}
			<div className="bg-info/10 border border-info/20 rounded-lg p-4">
				<div className="flex items-start space-x-3">
					<Lightbulb className="h-5 w-5 text-info mt-0.5 shrink-0" />
					<p className="text-sm text-info/90">
						{t("help.guideFeasibilityTip")}
					</p>
				</div>
			</div>
		</div>
	);
}
